"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable");require("core-js/modules/es6.function.name");


































































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { modelId: 0, //产品型号id
      name: '', //营销型号
      code: '', //工厂型号
      pickerOptions: { disabledDate: function disabledDate(time) {return time.getTime() > Date.now();} }, searchData: { showDialog: '', time: '', pageIndex: 1, pageSize: 10 }, //筛选表单
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      dialogList: [{ label: '否', value: 0 }, { label: '是', value: 1 }], //是否弹窗选项列表
      tableColumn: [{ label: '版本号', prop: 'version' }, { label: '是否弹窗', prop: 'showDialog', formatter: _formatter.isForceFormatter }, { label: '弹窗文案', prop: 'dialogContent' }, { label: '创建时间', prop: 'createTime' }], //表头数据
      tableData: [], //版本列表
      showAdd: false, //是否显示新增||编辑弹窗
      versionForm: { id: 0, model: '', version: '', showDialog: '', dialogContent: '' }, //新增||编辑表单
      versionFormRule: { model: [{ required: true, message: '请填写设备型号', trigger: ['blur', 'change'] }], version: [{ required: true, message: '请填写版本号', trigger: ['blur', 'change'] }], showDialog: [{ required: true, message: '请选择是否弹窗', trigger: ['change'] }],

        dialogContent: [{
          required: true,
          message: '请填写弹窗文案',
          trigger: ['blur', 'change'] }]
        //表单验证规则
      } };

  },

  mounted: function mounted() {
    this.modelId = this.$route.params.parentId;
    this.name = this.$route.params.name;
    this.code = this.$route.params.code;
    this.pageInit();
  },

  watch: {
    showAdd: {
      handler: function handler(val) {
        if (val) {
          this.$set(this.versionForm, 'model', this.name + '/' + this.code);
        }
      },
      deep: true } },



  computed: {
    versionModel: function versionModel() {
      return function (item) {
        return item.name + '/' + item.code;
      };
    } },


  methods: {
    /**
              * 页面初始化
              */
    pageInit: function pageInit() {
      this.fetchH5VersionList();
    },

    /**
        * 每页size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.searchData.pageSize = val;
      this.searchData.pageIndex = 1;
      this.fetchH5VersionList();
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.pageIndex = val;
      this.fetchH5VersionList();
    },

    /**
        * 获取版本信息列表
        */
    fetchH5VersionList: function fetchH5VersionList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      params.code = this.code;
      params.name = this.name;
      if (params.time) {
        params.startTime = params.time[0];
        params.endTime = params.time[1];
      }
      delete params['time'];
      if (params.showDialog.length <= 0) {
        delete params['showDialog'];
      }
      this.postData('/api/h5Version/versions', params, function (res) {
        _this.tableData = res.versionList;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 点击搜索
        */
    onClickSearch: function onClickSearch() {
      this.$set(this.searchData, 'pageIndex', 1);
      this.fetchH5VersionList();
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'showDialog', '');
      this.$set(this.searchData, 'time', '');
      this.$set(this.searchData, 'pageIndex', 1);
      this.fetchH5VersionList();
    },

    /**
        * 编辑
        */
    updateItem: function updateItem(item) {
      this.showAdd = true;
      this.$set(this.versionForm, 'id', item.id);
      this.$set(this.versionForm, 'model', item.name + '/' + item.code);
      this.$set(this.versionForm, 'version', item.version);
      this.$set(this.versionForm, 'showDialog', item.showDialog + '');
      this.$set(this.versionForm, 'dialogContent', item.dialogContent);
      this.$set(this.versionForm, 'id', item.id);
      this.$set(this.versionForm, 'id', item.id);
    },

    /**
        * 删除
        */
    delItem: function delItem(item) {var _this2 = this;
      this.$confirm('确定删除当前版本？', '提示', { type: 'warning' }).then(function (res) {
        //删除版本
        _this2.delData('/api/h5Version/version/' + item.id, {}, function (res) {
          _this2.$set(_this2.searchData, 'pageIndex', 1);
          _this2.fetchH5VersionList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 关闭弹窗
        */
    onDialogClose: function onDialogClose() {var _this3 = this;
      this.$nextTick(function () {
        Object.keys(_this3.versionForm).forEach(function (key) {
          _this3.$set(_this3.versionForm, key, key == 'id' ? 0 : '');
        });
        _this3.$refs.versionForm.clearValidate();
      });
      this.showAdd = false;
    },

    /**
        * 新增||保存版本
        */
    onSubmitVersion: function onSubmitVersion() {var _this4 = this;
      this.$refs.versionForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this4.versionForm);
          delete params['model'];
          params.code = _this4.code;
          params.name = _this4.name;
          params.showDialog = parseInt(params.showDialog);
          if (params.showDialog <= 0) {
            params.dialogContent = '';
          }
          _this4.postData('/api/h5Version/version', params, function (res) {
            _this4.onDialogClose();
            _this4.$set(_this4.searchData, 'pageIndex', 1);
            _this4.fetchH5VersionList();
          });
        }
      });
    } } };exports.default = _default;